/* eslint-disable no-useless-escape */
import _ from "underscore";

// Builds an array of object for Table to consume as headers
// names: array of objects with `name`, `id`, and `type`
// options: array of objects with `type` (required), width (required), fixed, transform, html
// append: an optional array of objects to append to the end of the headers
export const buildTableHeaders = (params) => {
	const { headerNames, options, append } = params;
	let headers = [];

	const defaultOption = _.find(options, (option) => {
		return option.type === "default";
	});

	const translateableColumnIds = ["title"];
	let relevancyHeader = null;
	_.each(headerNames, (headerName) => {
		const type =
			(headerName.type &&
				_.find(options, (option) => {
					return option.type === headerName.id;
				})) ||
			defaultOption;

		if (type) {
			const newHeader = {
				name: headerName.name,
				id: headerName.id,
				width: type.width,
				fixed: !!type.fixed,
				html: !!type.html,
				minWidth: type.minWidth,
				transform: type.transform,
				info: headerName.info,
				altFunction: type.altFunction,
				disableSort: type.disableSort,
				reverseSort: type.reverseSort,
				sortColumn: type.sortColumn,
				className: "notranslate",
				rowClassName: translateableColumnIds.includes(headerName.id) ? undefined : "notranslate",
			}
			if (headerName.name === "Relevancy") {
				relevancyHeader = newHeader;
			}
			else {
				headers.push(newHeader);
			}
		}
	});

	if (relevancyHeader) {
		headers.push(relevancyHeader);
	}

	if (append) {
		headers = [...headers, ...append];
	}

	return headers;
};

export const allQuotesSingle = (query) => {
	if (!query) {
		return "";
	} else {
		const doubleQuoteRegex = /"/gi;
		return query.replace(doubleQuoteRegex, "'");
	}
};

//Temporary fix for the Chinese stuff to not get broken when typing Pinyin due to update, will remove completely once Dynamo method is refactored

export const allQuotesDoubleTemporary = (query) => {
	if (!query) {
		return "";
	} else {
		const singleQuoteRegex = /'/gi;
		return query.replace(singleQuoteRegex, '"');
	}
};

export const allQuotesDouble = (query) => {
	//	if (!query) {
	//		return "";
	//	} else {
	//		const singleQuoteRegex = /'/gi;
	//		return query.replace(singleQuoteRegex, '"');
	//	}
	return query;
};
